import lgBanner1 from "../../Images/HQ Banner1.png";
import mbBanner1 from "../../Images/mb-HQ Banner1.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import "./Banner.css";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { ThemeContext } from "../../Contexts/ThemeContext";

const Banner = () => {
  const { searchText, setSearchText } = useContext(ThemeContext);
  const banner01 = window.innerWidth > 992 ? lgBanner1 : mbBanner1;
  const navigate = useNavigate();

  return (
    <div>
      <Swiper
        spaceBetween={30}
        effect={"fade"}
        navigation={window.innerWidth < 992 ? false : true}
        autoplay={{
          delay: 10000,
          disableOnInteraction: false,
        }}
        pagination={window.innerWidth < 700 ? false : { dynamicBullets: true }}
        modules={[Autoplay, EffectFade, Navigation, Pagination]}
        className="mySwiper h-auto"
      >
        <SwiperSlide>
          <Link to="/shop">
            <img
              className="w-[100vw] mx-auto h-auto"
              src="https://www.acml.com.au/wp-content/uploads/The-Skin-Care-Company-range-2023pink.jpg"
              alt="Eid sale"
            />
          </Link>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Banner;
